var _ = require('underscore');
var Marionette = require('marionette');
var Validation = require('validation');
var Dialog = require('Dialog');
var Dropdown = require('Dropdown');
var Entities = require('Entities');
var Grid = require('Grid');
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var Resources = EY.Consultation.Resources;

var Editor = Marionette.View.extend({
    events: {
        'blur @ui.answer': 'answer',
        'blur @ui.label': function () { this.model.set('name', this.ui.label.val()); },
        'click @ui.required': function () { this.model.set('required', this.ui.required.prop('checked')); }
    },
    regions: {
        type: '#type'
    },
    template: '#editCustomField',
    ui: {
        answer: '#answer',
        dropdown: '#dropdown',
        label: '#label',
        required: '#required'
    },
    initialize: function () {
        this.model.validation = _.extend(this.model.validation, {
            answer: function (value) { return this.get('customFieldTypeId') === 'CustomFieldType_Dropdown' && !value ? Labels.Choices : ''; }
        });
        Validation.bind(this);
    },
    onRender: function () {
        var answer = this.model.get('answer');
        var context = this;

        Dropdown.show({
            collection: new Entities.Enumerations(_.filter(Resources.Enumeration, { type: 'CustomFieldType' })),
            region: this.getRegion('type'),
            resourceKeyAttribute: 'id',
            selection: this.model.get('customFieldTypeId'),
            onSelectionChanged: function (custom) {
                if (custom.id != Lookups.CustomFieldType.Dropdown) {
                    context.model.set({ answer: '' });
                }
                context.model.set('customFieldTypeId', custom.id);
                context.ui.dropdown.removeClass('hidden').addClass(Lookups.CustomFieldType.Dropdown === custom.id ? '' : 'hidden');
            }
        });
        this.ui.answer.val(_.pluck(answer, 'id').join(';'));
        this.ui.required.prop('checked', this.model.get('required'));
    },
    onDestroy: function () {
        this.model.validation = _.extend(this.model.validation, { answer: { required: true } });
    },
    answer: function () {
        this.model.set('answer', !this.ui.answer.val() ? '' : _.map(this.ui.answer.val().split(';'), function (choice) {
            return {
                id: choice,
                text: choice
            };
        }));
    }
});

var dialog = function (collection, model) {
    var attributes = model.clone().attributes;

    return Dialog.show({
        cancelLabel: Labels.Cancel,
        headerLabel: Labels.CustomFields,
        saveLabel: Labels.OK,
        validate: model,
        view: new Editor({
            collection: collection,
            model: model
        })
    }).fail(function () {
        model.set(attributes);
    });
};

var Action = Marionette.View.extend({
    className: 'string-cell sortable renderable id',
    events: {
        'click @ui.delete': 'delete',
        'click @ui.edit': 'dialog'
    },
    tagName: 'td',
    template: '#customFieldGridAction',
    ui: {
        delete: '#delete',
        edit: '#edit'
    },
    'delete': function () {
        this.model.collection.remove(this.model);
    },
    dialog: function () {
        dialog(this.model.collection, this.model);
    }
});

var Choices = Marionette.View.extend({
    modelEvents: {
        'change:answer': 'render'
    },
    tagName: 'td',
    template: _.noop,
    onRender: function () {
        this.$el.html(_.pluck(this.model.get('answer'), 'id').join(';'));
    }
});

var Type = Marionette.View.extend({
    modelEvents: {
        'change:customFieldTypeId': 'render'
    },
    tagName: 'td',
    template: _.noop,
    onRender: function () {
        this.$el.html(Labels[this.model.get('customFieldTypeId')]);
    }
});

var Layout = Marionette.View.extend({
    events: {
        'click @ui.add': 'add'
    },
    regions: {
        grid: '#grid'
    },
    template: '#customFieldLayout',
    ui: {
        add: '#add'
    },
    add: function () {
        var collection = this.collection;
        var model = new Entities.CustomField();

        dialog(collection, model).always(function () {
            if (model.get('name')) {
                collection.add(model.set({ id: _.now(), order: collection.length + 1 }));
            }
        });
    }
});

var columns = function () {
    return [{ name: 'name', label: Labels.Label, editable: false, cell: 'string' },
    { name: 'customFieldTypeId', label: Labels.CustomFieldType, editable: false, cell: Type },
    { name: 'choices', label: Labels.Choices, editable: false, cell: Choices },
    { name: '', label: '', editable: false, cell: Action }];
};

module.exports.start = function (options) {
    var collection = options.collection;
    var region = options.region;
    var layout = new Layout({ collection: collection });

    region.show(layout);
    Grid.show({
        collection: collection,
        columns: columns(),
        region: layout.getRegion('grid')
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Questionnaire/QuestionnaireCustomFields.js